import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 300);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      className="scroll-top-btn"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Scroll to top"
    >
      <FaArrowUp size={18} />
      <style>{`
        .scroll-top-btn {
          position: fixed;
          right: 20px;
          bottom: 24px;
          z-index: 1050;
          width: 48px;
          height: 48px;
          border: none;
          border-radius: 50%;
          background: #FFD700;
          color: #111;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
          cursor: pointer;
          transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
          animation: scrollTopIn 0.25s ease;
        }

        .scroll-top-btn:hover {
          background: #ffc107;
          transform: translateY(-3px);
          box-shadow: 0 10px 22px rgba(0, 0, 0, 0.3);
        }

        .scroll-top-btn:active {
          transform: translateY(0);
        }

        @keyframes scrollTopIn {
          from {
            opacity: 0;
            transform: translateY(10px) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        @media (max-width: 575.98px) {
          .scroll-top-btn {
            right: 14px;
            bottom: 18px;
            width: 44px;
            height: 44px;
          }
        }
      `}</style>
    </button>
  );
};

export default ScrollToTopButton;
